import {merge, Box} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {testIdProps} from '@github-ui/test-id-props'
import type {Icon} from '@primer/octicons-react'
import {useEffect} from 'react'
import {useListViewItems} from '../ListView/ItemsContext'
import {ActionBar as GitHubUiActionBar, type ActionBarProps as GitHubUiActionBarProps} from '@github-ui/action-bar'

export type ListItemActionBarProps = Omit<GitHubUiActionBarProps, 'label' | 'variant'> & {
  /**
   * Override the icon used in the button that opens the action menu. Defaults to KebabHorizontalIcon.
   */
  anchorIcon?: Icon
  label?: GitHubUiActionBarProps['label']
  sx?: BetterSystemStyleObject
}
const defaultOuterContainerStyles: BetterSystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
  paddingRight: 3,
  minWidth: '56px',
  gridArea: 'actions',
  maxWidth: '200px',
  flexGrow: 2,
}

export const ActionBar = ({
  anchorIcon,
  sx: externalSx = {},
  label = 'list item action bar',
  ...props
}: ListItemActionBarProps) => {
  const {setAnyItemsWithActionBar, setHasResizableActionsWithActionBar} = useListViewItems()
  useEffect(() => setAnyItemsWithActionBar(true), [setAnyItemsWithActionBar])
  useEffect(() => {
    if (props.actions) setHasResizableActionsWithActionBar(true)
  }, [props.actions, setHasResizableActionsWithActionBar])

  const flexibleContainerSx = merge<BetterSystemStyleObject>(
    defaultOuterContainerStyles,
    props.actions
      ? {
          maxWidth: null,
        }
      : {},
  )
  const outerContainerSx = merge<BetterSystemStyleObject>(flexibleContainerSx, externalSx)
  return (
    <Box sx={outerContainerSx} {...testIdProps('listview-item-action-bar-container')}>
      <GitHubUiActionBar
        {...props}
        label={label}
        variant="menu"
        overflowMenuToggleProps={anchorIcon ? {icon: anchorIcon} : undefined}
      />
    </Box>
  )
}

try{ ActionBar.displayName ||= 'ActionBar' } catch {}